import { render, staticRenderFns } from "./SignersPage.vue?vue&type=template&id=42105521&scoped=true&"
import script from "./SignersPage.vue?vue&type=script&lang=js&"
export * from "./SignersPage.vue?vue&type=script&lang=js&"
import style0 from "./SignersPage.vue?vue&type=style&index=0&id=42105521&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42105521",
  null
  
)

export default component.exports